<mat-accordion class="mat-elevation-z0">
  <mat-expansion-panel class="mat-elevation-z0" hideToggle>

    <mat-expansion-panel-header>
      <mat-panel-title>
        <button mat-button><mat-icon>add</mat-icon> Add Group</button>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div class="mat-elevation-z1" style="padding:10px">
      <mat-form-field appearance="outline" style="padding-left: 3px;">
        <mat-label>Group Name</mat-label>
        <input matInput name="group" [(ngModel)]="newGroup.group">
      </mat-form-field>

      <br />

      <button mat-stroked-button (click)="saveGroup()"><mat-icon>save</mat-icon> SAVE</button>
    </div>



  </mat-expansion-panel>

</mat-accordion>
